import React, { useState } from 'react';
import './Projects.css';
import p2 from "./p2.png";
import p4 from "./p4.png";
import p5 from "./p5.png";
import p6 from "./p6.png";
import p7 from "./p7.png";
import p8 from "./p8.png";
import p9 from "./p9.png";
import p10 from "./p10.png";
import p11 from "./p11.png";
import p3_1 from "./p3-1.png";
import p3_2 from "./p3-2.png";
import p3_3 from "./p3-3.png";
import p3_4 from "./p3-4.png";
import p3_5 from "./P3-5.png";
import p3_6 from "./P3-6.png";
import p3_7 from "./p3-7.png";
import p3_8 from "./p3-8.png";
import { useNavigate } from 'react-router-dom';

// Badge → colour group (see .badge-* in Projects.css)
const BADGE_GROUP = {
  'iOS App': 'app',
  'Android App': 'app',
  'Web App': 'app',
  'Website': 'web',
  'SEO': 'growth',
  'Lead Generation': 'growth',
  'Automation': 'growth',
  'Newsletter': 'growth',
  'Cybersecurity': 'security',
  'Traffic Monitoring': 'security',
  'Booking & Payments': 'feature',
  'Google Calendar': 'feature',
  'CRM': 'feature',
  'AI': 'feature',
};

// Ordered by impact — most impressive first.
// Projects with photo: null show a placeholder until a screenshot is added.
const projects = [
  {
    title: 'June Health',
    badges: ['Automation', 'Lead Generation'],
    status: 'Ongoing',
    info: 'A healthcare startup that recently raised $2.4M. We were brought on to design and build their marketing automation and lead generation campaigns, turning their funding momentum into a steady pipeline of qualified leads. We continue to work with them today.',
    link: null,
    photo: null,
  },
  {
    title: 'Global Automation Technology',
    badges: ['Website'],
    info: 'A world-class automation company working with Tesla and Amazon needed a site that matched their scale. We built a custom site that reflects their innovation, professionalism, and national reach.',
    link: 'https://gatech.ca/',
    photo: p9,
  },
  {
    title: 'Snap Carts',
    badges: ['iOS App'],
    info: 'A receipt tracker and cart management app with over 22,000 downloads annually across Asia. Helps individuals and businesses track purchases, manage carts, and simplify spending at scale.',
    link: 'https://apps.apple.com/za/app/snapcarts/id1661589663',
    photo: p11,
  },
  {
    title: 'Super Trax & Dirt Trax',
    badges: ['Website', 'Cybersecurity', 'Traffic Monitoring', 'Newsletter'],
    status: 'Ongoing',
    info: 'A popular outdoor equipment review brand running two high-traffic sites and a large Pinterest following. We manage cybersecurity for both sites (hardening, updates, backups, and threat monitoring) and track traffic across their sites and Pinterest account. We also help produce and grow their newsletter.',
    link: null,
    photo: null,
  },
  {
    title: 'Next Play Hockey',
    badges: ['Website', 'SEO', 'Booking & Payments'],
    info: 'A Toronto hockey company offering seamless online booking for video coaching sessions. Ranked #1 on Google search SEO — players and parents can schedule, pay, and track development all in one place.',
    link: 'https://nextplayhockey.com/',
    photo: p7,
  },
  {
    title: 'Speed Habit Tracker',
    badges: ['iOS App', 'Android App'],
    info: 'Built for a high-performance hockey school in Burlington, ON and live on the App Store. Coaches and athletes track daily performance metrics with secure login, admin controls, and real-time graphs.',
    link: 'https://apps.apple.com/za/app/speed-habit-tracker/id6670226720?platform=iphone',
    photo: p5,
  },
  {
    title: 'FitVault',
    badges: ['iOS App', 'Android App', 'Web App'],
    info: 'A fitness app that lets trainers post workouts for clients online for free. Complete cross-platform solution on Apple App Store, Google Play Store, and web.',
    link: 'https://apps.apple.com/za/app/fitvault-fitness-app/id6443820434',
    photo: p4,
  },
  {
    title: 'LecturePal',
    badges: ['Web App', 'AI'],
    info: 'An AI notetaking app for university students. Upload lecture slides, click a button, and get clean precise notes in seconds. Full user auth, storage, and password recovery built in.',
    link: 'https://lecturepal.ca/',
    photo: p2,
  },
  {
    title: 'Daily Dabble',
    badges: ['iOS App'],
    info: 'Your one-stop app for daily brain teasers — featuring the world\'s most popular daily games including NYT\'s Wordle. Built to keep users sharp and coming back every day.',
    link: 'https://apps.apple.com/za/app/dailydabble/id1621862336?platform=iphone',
    photo: p10,
  },
  {
    title: 'Open Road Systems',
    badges: ['Website', 'SEO'],
    status: 'Ongoing',
    info: 'A security company stuck with a broken WordPress site. We rebuilt it from the ground up into a fast, fully functional site with proper SEO foundations, and we\'re actively working to push their search rankings higher.',
    link: null,
    photo: null,
  },
  {
    title: 'Bulletproof Interviewing',
    badges: ['Website', 'Booking & Payments', 'Google Calendar'],
    info: 'A fully online interview coaching company. We built a custom booking page where clients can schedule and pay in one step, synced with Google Calendar so the coach sets their own availability and never gets double-booked.',
    link: null,
    photo: null,
  },
  // {
  //   title: 'Coach Nye',
  //   badges: ['Website', 'Lead Generation'],
  //   info: 'An online mental performance coach who works specifically with hockey players. We built out his lead generation system and several of his sites, bringing in a consistent flow of players and parents looking for coaching.',
  //   link: null,
  //   photo: null,
  // },
  {
    title: 'RFR Pro',
    badges: ['Website'],
    info: 'Built for a competitive hockey training center — parents can explore programs, view schedules, and contact coaches from mobile. Engagement is up and registrations have increased since launch.',
    link: 'https://rfrpro.com/',
    photo: p3_5,
  },
  {
    title: 'Classic Fence & Deck',
    badges: ['Website', 'CRM'],
    info: 'A portfolio and lead-gen site for a local contractor, plus a custom CRM to manage their leads and jobs. Homeowners browse galleries and request quotes, and every request lands straight in the CRM so nothing slips through the cracks.',
    link: 'https://classicfenceanddeck.com/',
    photo: p3_4,
  },
  {
    title: 'SCORM Training',
    badges: ['Website'],
    info: 'A specialized LMS landing page for HR Proactive\'s online SCORM courses, designed to convert traffic from search and email into course purchases.',
    link: 'https://scormtraining.com/',
    photo: p3_1,
  },
  {
    title: 'Anti-Spam Training',
    badges: ['Website'],
    info: 'Part of HR Proactive\'s corporate compliance suite — a training portal delivering secure, trackable courses for Canadian businesses.',
    link: 'https://antispamtraining.com/',
    photo: p3_3,
  },
  {
    title: 'Bill 168 Workplace Harassment',
    badges: ['Website'],
    info: 'A focused campaign site for HR Proactive targeting Ontario\'s workplace harassment training requirements under Bill 168.',
    link: 'https://bill168.ca/',
    photo: p3_2,
  },
  {
    title: 'Snap Site',
    badges: ['Web App'],
    info: 'The 1-minute website builder with ultra-simple hosting for just $2/month. Built by a Hamilton founder — fast, affordable, and designed to get anyone online instantly.',
    link: 'https://snapsite.ca/',
    photo: p8,
  },
  {
    title: 'Robinson BnB',
    badges: ['Website', 'Booking & Payments'],
    info: 'A cozy Thorold bed and breakfast that needed a site reflecting its charm. Guests can view the space, check availability, and contact hosts. Direct bookings and online trust have increased significantly.',
    link: 'https://robinsongbnb.com/',
    photo: p3_6,
  },
  {
    title: 'WTF Burger Company',
    badges: ['Website'],
    info: 'Niagara-owned bold burgers with a brand to match. Their site reflects their high-energy style — customers explore the menu, location, and vibe before they walk in the door.',
    link: 'https://midnightblue-peafowl-834009.hostingersite.com/',
    photo: p3_8,
  },
  {
    title: 'Salt N Pepper Eats',
    badges: ['Website'],
    info: 'A clean, mobile-first catering site — customers browse menus, contact for events, and book services. Fast performance and simple layout built for clients on the go.',
    link: 'https://saltnpeppereats.ca/',
    photo: p3_7,
  },
  {
    title: 'BulletPlan',
    badges: ['iOS App'],
    info: 'A productivity app for high-performers. Secure local storage and a daily refresh cycle keep planning streamlined and distraction-free.',
    link: 'https://apps.apple.com/za/app/bulletplan/id1658811237?platform=iphone',
    photo: p6,
  },
];

const FILTERS = [
  { label: 'All',               match: () => true },
  { label: 'Websites',          match: p => p.badges.includes('Website') },
  { label: 'Apps',              match: p => p.badges.some(b => BADGE_GROUP[b] === 'app') },
  { label: 'Growth & Security', match: p => p.badges.some(b => ['growth', 'security'].includes(BADGE_GROUP[b])) },
];

const linkLabel = (link) =>
  link.includes('apps.apple.com') ? 'View on App Store →' : 'View Live Site →';

const Projects = () => {
  const navigate = useNavigate();
  const [active, setActive] = useState('All');

  const filtered = projects.filter(FILTERS.find(f => f.label === active).match);

  return (
    <div className="projects-container">

      {/* ── HEADER ── */}
      <div className="projects-header">
        <span className="projects-eyebrow">Our Work</span>
        <h1>120+ Projects. <em>Real Results.</em></h1>
        <p>
          From funded startups and apps with 30,000 organic downloads to websites ranking #1 on Google,
          here's a sample of what we've built for businesses across Ontario and beyond.
        </p>
      </div>

      {/* ── FILTERS ── */}
      <div className="projects-filters">
        {FILTERS.map(f => (
          <button
            key={f.label}
            className={`filter-btn${active === f.label ? ' active' : ''}`}
            onClick={() => setActive(f.label)}
          >
            {f.label}
          </button>
        ))}
      </div>

      {/* ── PROJECT LIST ── */}
      <div className="projects-list">
        {filtered.map((project) => {
          const Card = project.link ? 'a' : 'div';
          const cardProps = project.link
            ? { href: project.link, target: '_blank', rel: 'noopener noreferrer' }
            : {};
          return (
            <Card key={project.title} className="project-box" {...cardProps}>
              <div className="project-media">
                <div className="project-image">
                  {project.photo
                    ? <img src={project.photo} alt={project.title} />
                    : <div className="project-image-placeholder">{project.title}</div>}
                </div>
                <div className="project-badges">
                  {project.badges.map(b => (
                    <span key={b} className={`project-badge badge-${BADGE_GROUP[b] || 'web'}`}>{b}</span>
                  ))}
                </div>
              </div>
              <div className="project-text">
                {project.status && <span className="project-status">● {project.status}</span>}
                <h2>{project.title}</h2>
                <p>{project.info}</p>
                {project.link && <span className="project-link-label">{linkLabel(project.link)}</span>}
              </div>
            </Card>
          );
        })}
      </div>

      {/* ── MORE PROJECTS ── */}
      <div className="projects-more">
        <div>
          <p>This is just a sample of our work.</p>
          <span>We've completed 90+ websites and 15+ applications, contact us for the full portfolio.</span>
        </div>
        <button className="btn-primary" onClick={() => navigate('/contact')}>
          Get in Touch →
        </button>
      </div>

    </div>
  );
};

export default Projects;
